function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.12508 19.8752C1.55216 19.8752 1.06171 19.6712 0.653727 19.2632C0.245741 18.8552 0.041748 18.3647 0.041748 17.7918V4.25016H2.12508V17.7918H19.8334V19.8752H2.12508ZM6.29175 15.7085C5.71883 15.7085 5.22838 15.5045 4.82039 15.0965C4.41241 14.6885 4.20841 14.1981 4.20841 13.6252V2.16683C4.20841 1.59391 4.41241 1.10346 4.82039 0.695475C5.22838 0.287489 5.71883 0.0834961 6.29175 0.0834961H11.5001L13.5834 2.16683H20.8751C21.448 2.16683 21.9384 2.37082 22.3464 2.77881C22.7544 3.18679 22.9584 3.67725 22.9584 4.25016V13.6252C22.9584 14.1981 22.7544 14.6885 22.3464 15.0965C21.9384 15.5045 21.448 15.7085 20.8751 15.7085H6.29175ZM6.29175 13.6252H20.8751V4.25016H12.724L10.6407 2.16683H6.29175V13.6252Z",
  fill: "#E8A562"
});

var SvgRepositories = function SvgRepositories(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRepositories, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Repositories.71a36b8c.svg";
export { ForwardRef as ReactComponent };